import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { InstructionComponent } from './components/instruction.component';

export const routes: Routes = [
  {
    path: '',
    component: InstructionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class InstructionRoutesModule {}
